import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { EnvironmentService } from "../../../environment/environment.service";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  constructor(
    private readonly oAuthService: OAuthService,
    private readonly environmentService: EnvironmentService
  ) {}

  get userInfo(): GMUser {
    const claims = this.oAuthService.getIdentityClaims();
    this.gmUser = AuthenticationService.constructUserFromIdentityClaims(claims);
    return this.gmUser;
  }
  public gmUser: GMUser = new GMUser();

  /**
   * Creates a FabUser from the claims object passed in.
   * @param claims Object consisting of the user's properties
   * @private
   */
  private static constructUserFromIdentityClaims(claims: any): GMUser {
    let user: GMUser;
    if (claims) {
      user = {
        name: claims.name,
        userName: claims.givenName,
        email: claims.email,
        roles: claims.roles,
        admin:
          claims.roles != null &&
          claims.roles.indexOf("CPD_181858.Write") !== -1,
        gminId: claims.gmuniqueidentifier,
      };
    }
    return user;
  }

  async initialize(): Promise<boolean> {
    this.oAuthService.configure(this.environmentService.environment.auth);
    return this.oAuthService.loadDiscoveryDocumentAndLogin();
  }

  isLoggedIn(): boolean {
    return this.userInfo != null;
  }

  logOut() {
    return this.oAuthService.logOut();
  }

  getAuthorizationHeaderValue(): string {
    return this.gmUser == null
      ? ""
      : `Bearer ${this.oAuthService.getIdToken()}`;
  }

  enableSilentRenew(): void {
    this.oAuthService.setupAutomaticSilentRefresh();
  }

  manuallyRefreshToken(): Observable<any> {
    return of(this.oAuthService.silentRefresh());
  }
}

export class GMUser {
  userName: string;
  name: string;
  email: string;
  roles: string[];
  admin: boolean;
  gminId: string;
}
